import api from '../api'

export default {
    findByPackage: async (serial_number) => {
        const dataModel = (await api.get(`/package/${serial_number}`)).data
        return dataModel
    },

    ListByOrigin: async (unity, status = 0) => {
        const data = await api.get(`/package/origin/${unity}?status=${status}`)
        return data
    },
    packagesByModelOriginStatus: async (model,status, origin, skip, take) => {
        const data = await api.get(`/package/packagesByModelOriginStatus/${model}?origin=${origin}&status=${status}&skip=${skip}&take=${take}`)
        return data
    },
    packageByCustomerWithModel: async () => {
        const data = await api.get(`/package/packageByCustomerWithModel/`)
        return data
    },
    packagesByCustomer: async (fk_destino, skip, take) => {
        const data = await api.get(`/package/packagesByCustomer/${fk_destino}/?skip=${skip}&take=${take}`)
        return data
    },

    findPackage: async (serial_number) => {
        const data = await api.get(`/package/${serial_number}`)
        return data
    },
    createPackage: async ({FK_modelo, origem, serial_number}) => {
    
        const data = await api.post(`/package/`, {
            FK_modelo,
            origem,
            serial_number,
        })
        return data
    },

    updatePackage: async ( {id, FK_destino, origem, FK_modelo, status}) => {
        console.log("id", id);
        console.log("origem", origem);
        
        
        const data = await api.put(`/package`, {

            ids: [id],
            packages: [{
                FK_destino,
                origem,
                FK_modelo,
                status,
            }]        
        }
        )
        return data
    },

    updatePackageBatch: async (payload) => {
    return api.put(`/package`, payload);
    },

    updatePackageMnt: async ({id,FK_destino,origem ,FK_modelo,id_provider,descricao,status}) => {
        const data = await api.put(`/package/mnt/${id}`, {
            FK_destino ,
            origem,
            FK_modelo,
            id_provider,
            descricao,
            status,
        }
        
        )
        return data
    },
    
    listQuantityPackagesByModel: async (id) => {
        const data = (await api.get(`/package/model/${id}`)).data
        return data
    },

    listModelsAndTotalPackages: async () => {
        const data = (await api.get(`/package/origin/Geral`)).data
        return data
    }
}
